import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedCreate = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 100 100" width={width} height={height}>
            <path
                className={styles.cls1}
                d="M49.74,98.67A48.68,48.68,0,1,1,98.42,50,48.74,48.74,0,0,1,49.74,98.67Zm0-94.31A45.63,45.63,0,1,0,95.37,50,45.68,45.68,0,0,0,49.74,4.36Z"
            />
            <path
                className={styles.cls1}
                d="M54.06,59.8H26.15A2.78,2.78,0,0,1,23.38,57V32.27a2.77,2.77,0,0,1,2.77-2.77H65.26A2.78,2.78,0,0,1,68,32.27V46.66a.8.8,0,0,1-.8.79.79.79,0,0,1-.79-.79V32.27a1.19,1.19,0,0,0-1.19-1.19H26.15A1.19,1.19,0,0,0,25,32.27V57a1.19,1.19,0,0,0,1.19,1.19H54.06a.8.8,0,0,1,0,1.59Z"
            />
            <path
                className={styles.cls1}
                d="M54.06,60.56H26.15A3.55,3.55,0,0,1,22.61,57V32.27a3.55,3.55,0,0,1,3.54-3.54H65.26a3.55,3.55,0,0,1,3.54,3.54V46.66a1.56,1.56,0,0,1-3.11,0V32.27a.43.43,0,0,0-.43-.43H26.15a.43.43,0,0,0-.43.43V57a.43.43,0,0,0,.43.43H54.06a1.56,1.56,0,1,1,0,3.11ZM26.15,30.26a2,2,0,0,0-2,2V57a2,2,0,0,0,2,2H54.06s0,0,0,0L26.15,59A2,2,0,0,1,24.2,57V32.27a2,2,0,0,1,1.95-2H65.26a2,2,0,0,1,1.95,2V46.66l.06-14.39a2,2,0,0,0-2-2Z"
            />
            <path
                className={styles.cls1}
                d="M67.24,35.68H24.17a.79.79,0,1,1,0-1.58H67.24a.79.79,0,1,1,0,1.58Z"
            />
            <path
                className={styles.cls1}
                d="M67.24,36.45H24.17a1.56,1.56,0,1,1,0-3.11H67.24a1.56,1.56,0,1,1,0,3.11ZM24.17,34.86l43.07.06a0,0,0,0,0,0,0Z"
            />
            <path
                className={styles.cls1}
                d="M67.24,41.76H24.17a.8.8,0,0,1,0-1.59H67.24a.8.8,0,1,1,0,1.59Z"
            />
            <path
                className={styles.cls1}
                d="M67.24,42.52H24.17a1.56,1.56,0,1,1,0-3.11H67.24a1.56,1.56,0,1,1,0,3.11ZM24.17,40.93,67.24,41a0,0,0,0,0,0,0Z"
            />
            <path
                className={styles.cls1}
                d="M39.81,47.45H28.4a.8.8,0,0,1,0-1.59H39.81a.8.8,0,1,1,0,1.59Z"
            />
            <path
                className={styles.cls1}
                d="M39.81,48.21H28.4a1.56,1.56,0,0,1,0-3.11H39.81a1.56,1.56,0,1,1,0,3.11ZM28.4,46.62l11.41.07a0,0,0,0,0,0,0Z"
            />
            <path
                className={styles.cls1}
                d="M39.81,52.24H28.4a.79.79,0,0,1-.79-.8.79.79,0,0,1,.79-.79H39.81a.79.79,0,0,1,.8.79A.8.8,0,0,1,39.81,52.24Z"
            />
            <path
                className={styles.cls1}
                d="M39.81,53H28.4a1.56,1.56,0,0,1,0-3.11H39.81a1.56,1.56,0,1,1,0,3.11ZM28.4,51.41l11.41.06s0,0,0,0Z"
            />
            <path
                className={styles.cls1}
                d="M56.47,53.17a1.09,1.09,0,0,1-.25,0A4.29,4.29,0,1,1,61.72,48a.8.8,0,0,1-.58,1,.79.79,0,0,1-1-.57,2.71,2.71,0,1,0-3.46,3.24.79.79,0,0,1,.5,1A.8.8,0,0,1,56.47,53.17Z"
            />
            <path
                className={styles.cls1}
                d="M56.47,53.93a1.51,1.51,0,0,1-.48-.08,5.05,5.05,0,1,1,6.46-6.06,1.56,1.56,0,0,1-1.12,1.89,1.51,1.51,0,0,1-1.17-.16,1.53,1.53,0,0,1-.72-1A1.94,1.94,0,1,0,57,50.9a1.55,1.55,0,0,1-.48,3Zm1.09-8.41a3.53,3.53,0,0,0-1.1,6.89h0s0,0,0,0a3.53,3.53,0,0,1-2.41-3.33,3.47,3.47,0,0,1,6.83-.86A3.41,3.41,0,0,0,57.56,45.52Z"
            />
            <path
                className={styles.cls1}
                d="M67.24,70.09A11.09,11.09,0,1,1,78.33,59,11.09,11.09,0,0,1,67.24,70.09Zm0-20.58a9.5,9.5,0,1,0,9.5,9.5A9.51,9.51,0,0,0,67.24,49.51Z"
            />
            <path
                className={styles.cls1}
                d="M67.24,70.85A11.85,11.85,0,1,1,79.09,59,11.85,11.85,0,0,1,67.24,70.85Zm0-22.17A10.33,10.33,0,1,0,77.56,59,10.33,10.33,0,0,0,67.24,48.68Zm0,20.58A10.26,10.26,0,1,1,77.5,59,10.27,10.27,0,0,1,67.24,69.26Zm0-19A8.74,8.74,0,1,0,76,59,8.74,8.74,0,0,0,67.24,50.27Z"
            />
            <path
                className={styles.cls1}
                d="M67.24,64.64a.79.79,0,0,1-.79-.8V54.17a.79.79,0,0,1,.79-.8.8.8,0,0,1,.8.8v9.67A.8.8,0,0,1,67.24,64.64Z"
            />
            <path
                className={styles.cls1}
                d="M67.24,65.4a1.55,1.55,0,0,1-1.55-1.56V54.17a1.56,1.56,0,1,1,3.11,0v9.67A1.56,1.56,0,0,1,67.24,65.4Zm0-11.23-.06,9.67,0,0s0,0,0,0Z"
            />
            <path
                className={styles.cls1}
                d="M72.08,59.8H62.4a.8.8,0,0,1,0-1.59h9.68a.8.8,0,1,1,0,1.59Z"
            />
            <path
                className={styles.cls1}
                d="M72.08,60.56H62.4a1.56,1.56,0,0,1,0-3.11h9.68a1.56,1.56,0,1,1,0,3.11ZM62.4,59l9.68.07s0,0,0,0Z"
            />
        </svg>
    );
};

export default GetStartedCreate;
